import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ConfigService } from '../commons';
import { AnnualSalesData, ObjectivesData, GenericResponse } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class AnnualSalesService {
  annualSales = new BehaviorSubject<GenericResponse<AnnualSalesData>>(null);
  objectives = new BehaviorSubject<GenericResponse<ObjectivesData>>(null);
  data: AnnualSalesData;
  dataObjectives: ObjectivesData;

  constructor(private http: HttpClient, private config: ConfigService) {}

  getData() {
    return this.http.get<GenericResponse<AnnualSalesData>>(this.config.getUrl('grandesCuentas.getAnnualSales')).pipe(
      tap((res: GenericResponse<AnnualSalesData>) => {
        this.annualSales.next(res);
      })
    );
  }

  getObjectivesData() {
    return this.http.get<GenericResponse<ObjectivesData>>(this.config.getUrl('grandesCuentas.getObjectives')).pipe(
      tap((res: GenericResponse<ObjectivesData>) => {
        this.objectives.next(res);
      })
    );
  }

  setObjectivesData(data) {
    return this.http
      .post<GenericResponse<ObjectivesData>>(this.config.getUrl('grandesCuentas.setObjectives'), data)
      .pipe(
        tap((res: GenericResponse<ObjectivesData>) => {
          this.objectives.next(res);
        })
      );
  }
}
